/* Viperco tema betikleri: galeri, adet seçici, varyant fiyatı, koleksiyon filtresi, mobil menü */
(function () {
  // Ürün galerisi
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    gallery.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-thumb]');
      if (!btn) return;
      var id = btn.getAttribute('data-thumb');
      gallery.querySelectorAll('.gallery__slide').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-media-id') === id);
      });
      gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.setAttribute('aria-pressed', t === btn ? 'true' : 'false');
      });
    });
  });

  // Adet seçici
  document.querySelectorAll('[data-stepper]').forEach(function (st) {
    var input = st.querySelector('input');
    st.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]');
      if (!b) return;
      var v = parseInt(input.value, 10) || 1;
      v = Math.min(parseInt(input.max, 10) || 20, Math.max(1, v + parseInt(b.getAttribute('data-step'), 10)));
      input.value = v;
    });
  });

  // Varyant değişince fiyatı güncelle
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var root = sel.closest('[data-product]');
      var price = root && root.querySelector('[data-price]');
      if (price && opt) price.textContent = opt.getAttribute('data-price');
    });
  });

  // Koleksiyon filtresi (ürün türüne göre)
  document.querySelectorAll('[data-filter-tabs]').forEach(function (tabs) {
    var grid = document.querySelector('[data-filter-grid]');
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filter]');
      if (!b || !grid) return;
      var f = b.getAttribute('data-filter');
      tabs.querySelectorAll('[data-filter]').forEach(function (x) {
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      grid.querySelectorAll('.pcard').forEach(function (card) {
        card.hidden = !(f === 'all' || card.getAttribute('data-type') === f);
      });
    });
  });

  // Mobil menü: bağlantıya basınca ya da dışarı tıklayınca kapat
  var mnav = document.querySelector('[data-mnav]');
  if (mnav) {
    document.addEventListener('click', function (e) {
      if (mnav.open && !mnav.contains(e.target)) mnav.open = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') mnav.open = false;
    });
  }
})();
